var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.00122 13.1337C4.00122 17.4498 7.52259 20.9712 11.8387 20.9712C13.5427 20.9712 15.2467 20.4032 16.4961 19.3817L21.4936 24.3792L23.0842 22.7886L18.0867 17.7911C18.996 16.5417 19.6762 14.8377 19.6762 13.1337C19.6762 10.9762 18.767 9.04431 17.4053 7.56819C16.0415 6.20544 13.9973 5.29619 11.8387 5.29619C7.52259 5.29619 4.00122 8.81756 4.00122 13.1337ZM15.7013 9.15769C16.2091 9.66404 16.6111 10.2663 16.8839 10.9294C17.1568 11.5925 17.2951 12.3033 17.2908 13.0203C17.2908 14.4964 16.7228 15.8603 15.7013 16.8818C15.1952 17.3896 14.5932 17.7917 13.9303 18.0648C13.2674 18.3379 12.5568 18.4764 11.8398 18.4724C11.1227 18.4766 10.4119 18.3381 9.7488 18.065C9.08568 17.7919 8.48348 17.3897 7.97722 16.8818C6.84122 15.9726 6.27322 14.6109 6.27322 13.1337C6.27322 11.6576 6.84122 10.2937 7.86272 9.27219C8.88534 8.13619 10.3626 7.56819 11.8387 7.56819C13.316 7.56819 14.6787 8.13619 15.7002 9.15769H15.7013Z",
    fill: "#5E6673"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.dabbb384434d05e9fdb9e71a111b12f7.svg";
export { ForwardRef as ReactComponent };